module.exports = __webpack_public_path__ + "img/smoke5.249ac4e8.png";